import type { VendorPhotoType } from '@/features/onboarding/types';

/** Tags a vendor can file gallery photos under (backend GALLERY_PHOTO_TYPES). */
export type GalleryPhotoType = Extract<
  VendorPhotoType,
  'STORE_FRONT' | 'INTERIOR' | 'EXTERIOR' | 'GALLERY' | 'COUNTER' | 'STORAGE' | 'STAFF'
>;

export const GALLERY_PHOTO_TYPES: GalleryPhotoType[] = [
  'STORE_FRONT',
  'INTERIOR',
  'EXTERIOR',
  'GALLERY',
  'COUNTER',
  'STORAGE',
  'STAFF',
];

/** Backend cap per tag; exceeding it returns 422 PHOTO_TAG_LIMIT. */
export const MAX_PHOTOS_PER_TAG = 5;
export const MAX_PHOTO_BYTES = 5 * 1024 * 1024;
export const ALLOWED_PHOTO_MIME = ['image/jpeg', 'image/png', 'image/webp'];

export type GalleryPhoto = {
  id: string;
  type: GalleryPhotoType;
  display_order: number;
  original_filename: string;
  /** Authenticated path; append `?variant=thumb|medium|full` and render via AuthImage. */
  file_path: string;
  uploaded_at: string;
};

export type GalleryPhotoVariant = 'thumb' | 'medium' | 'full';

export function photo_variant_path(file_path: string, variant: GalleryPhotoVariant): string {
  return `${file_path}${file_path.includes('?') ? '&' : '?'}variant=${variant}`;
}
